/*eslint-disable*/
import React from "react";
import { Flex, Img, Link, List, ListItem, Text, useColorModeValue, useColorMode } from "@chakra-ui/react";

import PropTypes from "prop-types";
import svg1 from "assets/svg/svg1.svg";
import svg2 from "assets/svg/svg2.svg";
import svg3 from "assets/svg/svg3.svg";
import svg4 from "assets/svg/svg4.svg";
import svg5 from "assets/svg/svg5.svg";
import img6 from "assets/img/img1.png";
import img7 from "assets/img/img2.png";
import img8 from "assets/img/img3.png";

export default function Footer(props) {
  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <Flex direction="row" justifyContent="center" mb="40px" flexWrap="wrap" flexDirection={{lg: "row", sm: "column"}} alignItems="center">
      { colorMode === 'light' &&
        <Img m="20px" height="60px" src={svg2} />
      }
      { colorMode === 'light' &&
        <Img m="20px" height="60px" src={img7} />  
      }
      { colorMode === 'light' &&
        <Img m="20px" height="60px" src={svg1} />  
      }
      { colorMode === 'light' &&
        <Img m="20px" height="60px" src={svg3} />  
      }

      { colorMode === 'dark' &&
        <Img m="20px" height="60px" src={svg5} />  
      }
      { colorMode === 'dark' &&
        <Img m="20px" height="60px" src={img8} />  
      }
      { colorMode === 'dark' &&
        <Img m="20px" height="60px" src={svg4} />
      }
      { colorMode === 'dark' &&
        <Img m="20px" height="60px" src={img6} />  
      }
    </Flex>
  );
}
